/**
 * Next project Member ID as a pure integer string.
 * Only whole-string digit IDs count (e.g. "12"); prefixes like "EMP-3" are ignored.
 */
export function nextNumericMemberId(ids: string[]): string {
  let max = 0
  for (const raw of ids) {
    const id = raw.trim()
    if (!/^\d+$/.test(id)) continue
    const n = Number.parseInt(id, 10)
    if (Number.isFinite(n) && n > max) max = n
  }
  return String(max + 1)
}
